/**
 * SR 2026-10-24: part-number results in the instant search drawer.
 *
 * WHY THIS EXISTS. The drawer is Shopify's predictive search, which the theme calls with nothing
 * but q, resources[limit] and section_id. Predictive matches most SKUs, but not all of them.
 * Measured against 60 active products, asking exactly what the drawer asks: predictive found the
 * product by its own SKU 44 times, the full search page found it 52, and the 9 it missed were
 * nearly all Eibach numbers with dots or many segments (E60-82-008-02-01, 5.72130K, 2895.320,
 * S90-2-10-004, ETWE2.5). Typing one of those gave the shopper nothing until they pressed Enter,
 * which is exactly what Sean reported.
 *
 * WHAT IT DOES. After the drawer renders, if the query looks like a part number and the rendered
 * results do not already contain it as a SKU, it asks the FULL search engine through an alternate
 * view (templates/search.part-number.liquid, layout none) and appends those rows under their own
 * heading. The view only emits products whose SKU or barcode actually contains the query, so this
 * never duplicates the keyword results the drawer already shows.
 *
 * It only ever ADDS a group. Any failure leaves the drawer exactly as the theme rendered it.
 */
(function () {
  "use strict";

  if (window.__srSkuSearch) return;
  window.__srSkuSearch = true;

  var MIN = 3;
  var GROUP = "data-sr-sku-group";

  /* Worth a lookup: has a digit, and no spaces except the ones part numbers use (KONI's
     "1125 1011"). A two-word phrase like "coilovers for" never reaches the network. */
  function looksLikePartNumber(q) {
    if (!q || q.length < MIN) return false;
    if (!/\d/.test(q)) return false;
    if (q.split(/\s+/).length > 2) return false;
    return /^[A-Za-z0-9][A-Za-z0-9.\-_/ ]*$/.test(q);
  }

  function loose(s) {
    return String(s).toUpperCase().replace(/[^A-Z0-9]/g, "");
  }

  /* Does what the drawer already rendered include this number as a SKU? The SKU line comes from
     product-card-horizontal's show_sku, which predictive search results now carry. */
  function alreadyShown(container, q) {
    var want = loose(q);
    var skus = container.querySelectorAll(".horizontal-product__sku");
    for (var i = 0; i < skus.length; i++) {
      if (loose(skus[i].textContent).indexOf(want) !== -1) return true;
    }
    return false;
  }

  function fetchPartNumbers(q) {
    var url = "/search?q=" + encodeURIComponent(q) + "&type=product&view=part-number";
    return fetch(url, { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.text() : ""; })
      .catch(function () { return ""; });
  }

  var seq = 0;

  function run(container) {
    try {
      var form = container.closest("form") || document;
      var input = form.querySelector('input[name="q"]');
      var q = input ? input.value.trim() : "";
      if (!looksLikePartNumber(q)) return;
      if (container.querySelector("[" + GROUP + "]")) return;
      if (alreadyShown(container, q)) return;

      var mine = ++seq;
      fetchPartNumbers(q).then(function (html) {
        if (mine !== seq || !html || !html.trim()) return;
        /* The container may have been re-rendered while we were waiting. */
        if (!container.isConnected) return;
        if (input && input.value.trim() !== q) return;
        if (container.querySelector("[" + GROUP + "]")) return;

        var holder = document.createElement("div");
        holder.innerHTML = html;
        var group = holder.querySelector("[" + GROUP + "]");
        if (!group) return;
        container.insertBefore(group, container.firstChild);
      });
    } catch (e) {
      /* leave the drawer as the theme rendered it */
    }
  }

  /* The theme replaces the results container's contents on every keystroke's render, so watch for
     those renders rather than hooking the input: that way this works in the drawer, the header and
     on the search page without knowing which one it is. */
  function watch() {
    var containers = document.querySelectorAll(".search__results");
    for (var i = 0; i < containers.length; i++) {
      (function (c) {
        if (c.__srWatched) return;
        c.__srWatched = true;
        var debounce;
        new MutationObserver(function () {
          clearTimeout(debounce);
          debounce = setTimeout(function () { run(c); }, 250);
        }).observe(c, { childList: true, subtree: true });
        run(c);
      })(containers[i]);
    }
  }

  function boot() {
    watch();
    /* Drawer and header sections can be swapped in later by the theme. */
    new MutationObserver(function () { watch(); }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
